import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/User';
import Loader from '../spinner/Spinner';
import AccessDenied from '../custom/AccessDenied';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useUser();
  const location = useLocation();

  console.log(user.user_category)

  if (user === null) {
    return <Loader />;
  }
  return allowedRoles.includes(user.user_category.toUpperCase()) ? (
    children
  ) : (
    <AccessDenied/>
  );
};

export default ProtectedRoute;
